
import fetchQuantification from './fetchQuantification'
import fetchServiceConcept from './fetchServiceConcept'
import updateQuantification from './updateQuantification'
import updateSupplies from './updateSupplies'
import sendQuantification from './sendQuantification'
import makeRequisition from './makeRequisition'
import createDeliveryReceiptCertification from './createDeliveryReceiptCertification'
import fetchDeliveryReceiptEmailSize from './fetchDeliveryReceiptEmailSize'
import fetchRequisition from './fetchRequisition'
import sendQuotation from './sendQuotation'
import fetchSupplyHighwaySupplies from './supplyhighway/fetchSupplyHighwaySupplies'
import fetchSupplyHighway from './supplyhighway/fetchSupplyHighway'
import fetchQuotations from './fetchQuotations'
import sendMaterialQuotation from './sendMaterialQuotation'
import fetchPurchaseOrders from './fetchPurchaseOrders'
import fetchPurchaseOrdersWithoutFreight from './fetchPurchaseOrdersWithoutFreight'
import sendFreight from './sendFreight'
import sendBudget from './sendBudget'
import record from './record'
import downloadBinnacle from './downloadBinnacle'
import searchConcept from './searchConcept'
import fetchProviders from './fetchProviders'
import fetchFreight from './fetchFreight'
import fetchCompleteOCs from './fetchCompleteOCs'
import fetchOcsForFreights from './fetchOcsForFreights'
import fetchFreightSubtotal from './fetchFreightSubtotal'
import updateFreight from './updateFreight'
import fetchPurchaseReport from './fetchPurchaseReport'
import createSupplyCopy from './createSupplyCopy'
import replaceSupplies from './replaceSupplies'
import fetchInvoices from './fetchInvoices'
import sendBuyOrderPayment from './sendBuyOrderPayment'
import requestOrders from './requestOrders'
import fetchOnlyInvoice from './fetchOnlyInvoice'
import uploadInvoiceOrder from './uploadInvoiceOrder'
import fetchSuppliesABC from './fetchSuppliesABC'
import fetchConceptsValidation  from './fetchConceptsValidation'
import sendRejectedSinister from './sendRejectedSinister'
import getWorkGenerator from './fetchWorkGenerator'
import fetchRealQuantities from './fetchRealQuantities'
import sendRealQuantities from './sendRealQuantities'
import suppliesHistory from './fetchSuppliesHistory'
import rejectQuantification from './rejectQuantification'
import fetchPreviewSupplies from './fetchPreviewSupplies'
import setAsideForSinister from './setAsideForSinister'
import addSupplyToConcept from './addSupplyToConcept'
import getSupplyToAddToConcept from './getSupplyToAddToConcept'
import sendCommercialAgreements from './sendCommercialAgreements'
import fetchCommercialAgreements from './fetchCommercialAgreements'
import returnSuppliesAmount from './returnSuppliesAmount'
import requestExtraAmount from './requestExtraAmount'

import updatePurchaseOrder from './updatePurchaseOrder'
import fetchPurchaseOrder from './fetchPurchaseOrder'

export default {
  record,
  downloadBinnacle,
  sendQuantification,
  updateQuantification,
  updateSupplies,
  searchConcept,
  fetchQuantification,
  makeRequisition,
  createDeliveryReceiptCertification,
  fetchDeliveryReceiptEmailSize,
  fetchRequisition,
  sendQuotation,
  fetchQuotations,
  fetchSupplyHighway,
  fetchSupplyHighwaySupplies,
  sendMaterialQuotation,
  fetchPurchaseOrders,
  fetchPurchaseOrdersWithoutFreight,
  sendFreight,
  sendBudget,
  fetchProviders,
  fetchFreight,
  fetchCompleteOCs,
  fetchOcsForFreights,
  fetchFreightSubtotal,
  updateFreight,
  fetchServiceConcept,
  fetchPurchaseReport,
  createSupplyCopy,
  replaceSupplies,
  fetchInvoices,
  sendBuyOrderPayment,
  requestOrders,
  fetchOnlyInvoice,
  uploadInvoiceOrder,
  fetchSuppliesABC,
  fetchConceptsValidation,
  sendRejectedSinister,
  getWorkGenerator,
  fetchRealQuantities,
  sendRealQuantities,
  suppliesHistory,
  rejectQuantification,
  fetchPreviewSupplies,
  setAsideForSinister,
  addSupplyToConcept,
  getSupplyToAddToConcept,
  sendCommercialAgreements,
  fetchCommercialAgreements,
  returnSuppliesAmount,
  requestExtraAmount,
  updatePurchaseOrder,
  fetchPurchaseOrder
}



// WEBPACK FOOTER //
// ./src/services/purchase/index.js